<template>
  <div>
    <b-row >
      <b-form-group
        id="input-module-session-add"
        :label="$t('parametrics.sessionToAdd')"
        label-for="module-title-add"
        label-align="left"
        class="col-8"
      >
        <b-input v-model="sessionToAdd.title">

        </b-input>
      </b-form-group>
      <b-button class="esep-blue-bg ml-auto my-auto mr-3" variant="primary" @click="addSession" :disabled="!sessionToAdd.title || !module">
        {{ $t("common.add") }}
      </b-button>
    </b-row>
    <b-table 
      :items="sessions"
      :fields="fields"
      :filter="searchString"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :per-page="perPage"
      :current-page="currentPage"
      responsive
      show-empty
      ref="sessionsTable"
      class="mt-2"
      thead-class="esep-blue-bg text-light"
    >      
      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="deleteSession(row)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('parametrics.deleteSession')"
        >
          <b-icon icon="trash" ></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("parametrics.emptySessionsTable") }}</h6>
      </template>

    </b-table>

    <b-row>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="sessions-table"
          variant="info"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import trainingService from '../../services/training.service';
import {handleApiError} from "../../services/error.service";

export default {
  computed: {
    rows() {
      return this.sessions? this.sessions.length : 0;
    }
  },
  props: {
    module: Object,
    sessions: Array
  },
  data() {
    return {
      popSuccessAlert: false,
      successMessage: null,
      perPage: 10,
      currentPage: 1,
      pageOptions: [
        10,
        20,
        50,
        {
          value: Number.MAX_SAFE_INTEGER,
          text: "All",
        },
      ],
      sortBy: "title",
      sortDesc: false,
      fields: [
        { key: "title", label: "Τίτλος", sortable: true },
        { key: "action", label: "Ενέργεια", sortable: false  }
      ],
      filterOn: ["title"],
      searchString: "",
      sessionToAdd: {
        title: null,
        type: 'LESSON',
        module: this.module
      }
    }
  },
  methods: {
    addSession() {
      this.$log.debug(this.sessionToAdd);
      trainingService.addSession(this.sessionToAdd).then(
        (response) => {
          this.$log.debug(response.data);
          this.$emit('refresh-list',this.module);
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    deleteSession(row) {
      this.$log.debug(row)
      trainingService.deleteSession(row.item.id).then(
        (response) => {
          this.$log.debug(response.data);
          this.$emit('refresh-list',this.module);
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    }
  }
}
</script>